"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gradual = exports.slow = exports.smooth = exports.fast = void 0;
exports.fast = "130ms";
exports.smooth = "230ms";
exports.slow = "350ms";
exports.gradual = "530ms";